/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./dollar-sign.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./dollar-sign.component";
var styles_DollarSignComponent = [i0.styles];
var RenderType_DollarSignComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_DollarSignComponent, data: {} });
export { RenderType_DollarSignComponent as RenderType_DollarSignComponent };
export function View_DollarSignComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "span", [["class", "currency-sign"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["$"]))], null, null); }
export function View_DollarSignComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-dollar-sign", [], null, null, null, View_DollarSignComponent_0, RenderType_DollarSignComponent)), i1.ɵdid(1, 114688, null, 0, i2.DollarSignComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DollarSignComponentNgFactory = i1.ɵccf("cc-dollar-sign", i2.DollarSignComponent, View_DollarSignComponent_Host_0, {}, {}, []);
export { DollarSignComponentNgFactory as DollarSignComponentNgFactory };
